(() => {
  'use strict';

  const termsSelector = '[data-zgr-cart-terms]';

  const inputSelector =
    `${termsSelector} [data-zgr-terms-input]`;

  const checkoutSelector = [
    '#checkout',
    'button[name="checkout"]',
    'a[href*="/checkout"]',
    'shopify-accelerated-checkout',
    'shopify-payment-button',
    '.shopify-payment-button__button'
  ].join(',');

  const errorText =
    'Bitte bestätige, dass du mindestens 18 Jahre alt bist.';

  const getTermsInput = () => {
    return document.querySelector(inputSelector);
  };

  const setInvalidState = (input, invalid) => {
    if (!input) return;

    const wrapper = input.closest(termsSelector);

    if (!wrapper) return;

    const error = wrapper.querySelector('[data-zgr-terms-error]');

    wrapper.classList.toggle('is-invalid', invalid);

    input.setAttribute(
      'aria-invalid',
      invalid ? 'true' : 'false'
    );

    if (error) {
      error.hidden = !invalid;
      error.textContent = errorText;
    }
  };

  const focusTermsInput = (input) => {
    if (!input) return;

    setInvalidState(input, true);

    try {
      input.focus({ preventScroll: true });
    } catch {
      input.focus();
    }

    const wrapper = input.closest(termsSelector);

    if (wrapper) {
      wrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };

  const isValid = (input) => {
    return Boolean(input && input.checked);
  };

  const saveTermsAttribute = async (accepted) => {
    const shopifyRoot =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    const response = await fetch(
      `${shopifyRoot}cart/update.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            terms_accepted: accepted ? 'yes' : ''
          }
        })
      }
    );

    if (!response.ok) {
      throw new Error(
        `Cart attribute could not be saved: ${response.status}`
      );
    }

    return response.json();
  };

  const isCheckoutSubmitter = (submitter) => {
    if (!submitter || !(submitter instanceof Element)) {
      return false;
    }

    return (
      submitter.matches(checkoutSelector) ||
      submitter.id === 'checkout' ||
      submitter.name === 'checkout'
    );
  };

  const getCheckoutControl = (target) => {
    if (!(target instanceof Element)) {
      return null;
    }

    return target.closest(checkoutSelector);
  };

  const blockCheckout = (event, input) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    focusTermsInput(input);
  };

  document.addEventListener('change', (event) => {
    const input = event.target;

    if (
      !(input instanceof HTMLInputElement) ||
      !input.matches(inputSelector)
    ) {
      return;
    }

    setInvalidState(input, false);

    saveTermsAttribute(input.checked).catch((error) => {
      console.warn(
        '[ZGR Cart Terms] Could not save cart attribute.',
        error
      );
    });
  });

  document.addEventListener(
    'click',
    (event) => {
      const checkoutControl = getCheckoutControl(event.target);

      if (!checkoutControl) {
        return;
      }

      const input = getTermsInput();

      if (!isValid(input)) {
        blockCheckout(event, input);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;

      if (!isCheckoutSubmitter(submitter)) {
        return;
      }

      const input = getTermsInput();

      if (!isValid(input)) {
        blockCheckout(event, input);
      }
    },
    true
  );

  document.addEventListener(
    'invalid',
    (event) => {
      const input = event.target;

      if (
        input instanceof HTMLInputElement &&
        input.matches(inputSelector)
      ) {
        setInvalidState(input, true);
      }
    },
    true
  );
})();